"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultAmbientValueInjector = void 0;
const DefaultAmbientValueResolver_1 = require("./DefaultAmbientValueResolver");
const AmbientValueInjector_1 = require("./AmbientValueInjector");
class DefaultAmbientValueInjector extends AmbientValueInjector_1.AmbientValueInjector {
    constructor() {
        super(new DefaultAmbientValueResolver_1.DefaultAmbientValueResolver());
    }
}
exports.DefaultAmbientValueInjector = DefaultAmbientValueInjector;
//# sourceMappingURL=DefaultAmbientValueInjector.js.map